import { FC, useEffect, useState } from 'react';
import { Card, CardContent, CardHeader } from '@mui/material';
import { SeriesLineOptions } from 'highcharts';
import { parseISO } from 'date-fns';
import { DeviceDetailedHealth, SignalHistoryEntry } from 'types';
import SimpleLineGraph from 'components/SimpleLineGraph/SimpleLineGraph';
import styles from './DeviceHealthSignalCard.module.scss';

interface DeviceHealthSignalCardProps {
    health: DeviceDetailedHealth | null;
}

const getRsrpLine = (batteryHist: SignalHistoryEntry[]) => {
    const output = [];
    for (const entry of batteryHist) {
        output.push({
            x: Number(parseISO(entry.time)),
            y: entry.rsrp,
        });
    }
    return output;
};

const getRsrqLine = (batteryHist: SignalHistoryEntry[]) => {
    const output = [];
    for (const entry of batteryHist) {
        output.push({
            x: Number(parseISO(entry.time)),
            y: entry.rsrq,
        });
    }
    return output;
};

const DeviceHealthSignalCard: FC<DeviceHealthSignalCardProps> = ({
    health,
}) => {
    const [series, setSeries] = useState<SeriesLineOptions[]>([]);

    useEffect(() => {
        if (!health) return;
        const tempSeries: SeriesLineOptions[] = [
            { type: 'line', color: '#ff7f0e', name: 'rsrq' },
            { type: 'line', color: '#1f77b4', name: 'rsrp' },
        ];
        tempSeries[0].data = getRsrqLine(health.signalHist);
        tempSeries[1].data = getRsrpLine(health.signalHist);
        tempSeries[0].tooltip = {
            valueDecimals: 1,
            xDateFormat: '%b %e %l:%M %p',
        };
        tempSeries[1].tooltip = {
            valueDecimals: 1,
            xDateFormat: '%b %e %l:%M %p',
        };
        setSeries(tempSeries);
    }, [health]);

    return (
        <div
            className={styles.DeviceHealthSignalCard}
            data-testid="DeviceHealthSignalCard"
        >
            <Card>
                <CardHeader title="Signal Chart" />
                <CardContent>
                    <SimpleLineGraph series={series} />
                </CardContent>
            </Card>
        </div>
    );
};

export default DeviceHealthSignalCard;
